import { monthNames } from 'constants/Data';
import moment from 'moment-timezone';
import toast from 'react-hot-toast';
import { WarningOutlined, CloseOutlined } from '@ant-design/icons'; // Import the Ant Design icons
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = process.env.REACT_APP_TIMEZONE || 'America/New_York';

export const toastText = (message: string, type: string, duration = 5000, closable = true) => {
	const getToastContent = () => {
		const baseStyles = {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			padding: '10px 15px',
			borderRadius: '8px',
			fontSize: '16px',
			minWidth: 'fit-content',
			maxWidth: '500px',
			width: 'auto',
		};

		let contentStyles = {};

		switch (type) {
			case 'success':
				contentStyles = {
					...baseStyles,
					color: 'white',
					backgroundColor: '#008f47',
				};
				break;
			case 'error':
				contentStyles = {
					...baseStyles,
					color: 'white',
					backgroundColor: '#ff0000',
				};
				break;
			case 'info':
			default:
				contentStyles = {
					...baseStyles,
					color: 'white',
					backgroundColor: '#344735',
					backdropFilter: 'blur(10px)',
					WebkitBackdropFilter: 'blur(10px)',
				};
				break;
		}

		return (
			<div style={contentStyles}>
				<div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
					{type === 'info' && (
						<WarningOutlined
							style={{ marginRight: '8px', fontSize: '20px', color: '#f7c600' }}
						/>
					)}
					<span>{message}</span>
				</div>
				{closable && (
					<CloseOutlined
						onClick={() => toast.dismiss()}
						style={{
							cursor: 'pointer',
							fontSize: '16px',
							marginLeft: '10px',
							color: 'white',
						}}
					/>
				)}
			</div>
		);
	};

	toast.custom(getToastContent, {
		duration,
	});
};

export const formatPhoneNumber = (phoneNumber: string) => {
	// Remove all non-numeric characters from the input
	const cleanedNumber = phoneNumber.replace(/\D/g, '');

	// Define the phone number format (e.g., "(XXX) XXX-XXXX")
	const format = '($1) $2-$3';

	// Apply the mask to the cleaned number using a regular expression
	const maskedNumber = cleanedNumber.replace(/(\d{3})(\d{3})(\d{4})/, format);

	return maskedNumber;
};

export const getMonthAfter12Months = (currentMonth: number) => {
	// Parse the input month to a Date object
	const date = new Date(`2023-${currentMonth}-01`); // We assume the year is 2023 for simplicity

	// Add 12 months to the current date
	date.setMonth(date.getMonth() + 11);

	// Get the new month (0-11, where 0 is January and 11 is December)
	const newMonth = date.getMonth();

	// Return the new month as a number (add 1 to get the month number in the range 1-12)

	return monthNames[newMonth];
};

export const getPermissionObject = (
	permissionObj: any,
	allPermissions: any
) => {
	let formattedArray: any = [];
	const updatedAllPermission = allPermissions.map((singlePermission: any) => {
		return {
			...singlePermission,
			isBold: false,
		};
	});

	// const updatedPermissionObj = []
	for (const singlePermissionObj of permissionObj) {
		let tempArray = [];
		if (singlePermissionObj.name) {
			tempArray.push({
				permissionName: singlePermissionObj.name,
				isBold: true,
			});
		}

		const filteredPermissions = updatedAllPermission.filter(
			(singlePermission: any) => {
				return singlePermissionObj.items.includes(singlePermission.sortId);
			}
		);
		tempArray = [...tempArray, ...filteredPermissions];
		formattedArray = [...formattedArray, ...tempArray];
	}

	return formattedArray;
};

export const checkPermission = (
	allPermissions: any,
	requiredPermission: any
) => {
	if (!allPermissions) {
		return false;
	}
	const permissionsList = allPermissions;
	const permission = permissionsList?.find(
		(singlePermission: any) =>
			singlePermission.permissionName === requiredPermission.permissionName
	);

	if (permission) {
		const permitted = requiredPermission.permission.some(
			(singlePermission: string) => permission[singlePermission]
		);
		return permitted || permission['all'];
	} else {
		return false;
	}
};

export const isValidConfigurationSettings = (
	configurationsDataCopy: any,
	indirectExpenseRate: number | null
) => {
	let fields: any = [];
	let remainingId = null;
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const _indirectExpenseRate = indirectExpenseRate;

	for (const configuration of Object.values(configurationsDataCopy) as any) {
		fields = [...fields, ...Object.values(configuration.fields)];
	}

	for (const configuration of Object.values(configurationsDataCopy) as any) {
		const fondedConfiguration: any = Object.values(configuration.fields).find(
			(el: any) => el.isEditing === true
		);
		if (fondedConfiguration) {
			remainingId = `${configuration.id}${fondedConfiguration.id}`;
			break;
		}
	}

	//const isValid = fields.every((singleField: any) => singleField.value);

	//NOTE: if somehow in future this validation not work comment down the below code and un comment the above code.

	const _isValid = true;
	let _isValidCreditAccount = true;

	let shouldBreak = false;

	for (const configuration of Object.values(configurationsDataCopy) as any) {
		const sectionFields: any[] = Object.values(configuration.fields);

		if (shouldBreak) {
			break;
		}

		for (const field of sectionFields) {
			// console.log('indirect expense', indirectExpenseRate)
			// if (
			// 	configuration.id !== '5' &&
			// 	!(configuration.id == '0' && field.id === 'f1') &&
			// 	!(configuration.id == '4' && !indirectExpenseRate) &&
			// 	!(
			// 		configuration.id == '0' &&
			// 		field.id === 'f2' &&
			// 		!indirectExpenseRate
			// 	) &&
			// 	field.isActive
			// ) {
			// 	_isValid = hasText(field.value);
			// }
			if (
				(configuration.id === '1' ||
					configuration.id === '2' ||
					configuration.id === '3') &&
				field.isActive
			) {
				_isValidCreditAccount = hasText(field.creditValue);
			}

			if (!_isValid) {
				shouldBreak = true;
				break;
			}
			if (!_isValidCreditAccount) {
				shouldBreak = true;
				break;
			}
		}
	}

	const isAllEditableDone = fields.every(
		(singleField: any) => singleField.isEditing === false
	);

	const isBlankLabel = fields.some(
		(singleField: any) => singleField.label.trim() === ''
	);
	return {
		isValidSelectBox: _isValid && _isValidCreditAccount,
		isAddEditFalse: isAllEditableDone,
		isBlankLabel: isBlankLabel,
		remainingId: remainingId,
	};
};

export const filterQBEntities = (
	configurationsDataCopy: any,
	type: string,
	qbValues: any
) => {
	const qbValuesCopy = JSON.parse(JSON.stringify(qbValues));
	let fields: any = [];
	const filteredItems: any = [];

	for (const configuration of Object.values(configurationsDataCopy) as any) {
		if (configuration.type === type) {
			fields = [...fields, ...Object.values(configuration.fields)];
		}
	}

	const fieldsSelectedValues = fields.map(
		(singleField: any) => singleField.value
	);

	const creditFieldsSelectedValues = fields.map(
		(singleField: any) => singleField.creditValue
	);

	qbValuesCopy.forEach((single: any) => {
		if (
			fieldsSelectedValues.includes(single.Id) ||
			creditFieldsSelectedValues.includes(single.Id)
		) {
			single.isDisable = true;
			filteredItems.push(single);
		} else {
			filteredItems.push(single);
		}
	});
	return filteredItems;
};

export const phoneNumberFormatHandler = (phoneNumber: any = '') => {
	const inputPhoneNumber = phoneNumber?.replace(/\D/g, ''); // Remove non-digit characters
	let formattedPhoneNumber = '';

	if (inputPhoneNumber.length > 0) {
		formattedPhoneNumber = `(${inputPhoneNumber.slice(0, 3)}`;

		if (inputPhoneNumber.length >= 4) {
			formattedPhoneNumber += `) ${inputPhoneNumber.slice(3, 6)}`;
		}

		if (inputPhoneNumber.length >= 7) {
			formattedPhoneNumber += `-${inputPhoneNumber.slice(6, 10)}`;
		}
	}

	return formattedPhoneNumber;
};

export const TimeAgo = (date: any) => {
	// const sourceTimeZone = 'America/Los_Angeles';
	const localDate = moment(date).utcOffset(new Date().getTimezoneOffset() * -1);
	const formattedTimeAgo = localDate.fromNow();

	return formattedTimeAgo;
	// return <span>{formattedTimeAgo}</span>;
};

export const checkTimeFormat = (value: string) => {
	let result = true;
	for (let i = 0; i < value.length; i++) {
		if (
			!(value.charCodeAt(i) >= 48 && value.charCodeAt(i) <= 58) ||
			value === ''
		) {
			result = false;
			break;
		}
	}
	return result;
};

export function convertToHyphenCase(inputString: string) {
	// Convert the input string to lowercase
	const lowerCaseString = inputString.toLowerCase();

	// Replace spaces with hyphens
	const hyphenCaseString = lowerCaseString.replace(/\s+/g, '-');

	return hyphenCaseString;
}

export function formatTimeHours(
	hours: string | number,
	minutes: string | number,
	isDecimal = false
): string {
	const hoursNum = Number(hours) || 0;
	const minutesNum = Number(minutes) || 0;

	if (isDecimal) {
		// Format as decimal: 4.50
		const totalHours = hoursNum + (minutesNum / 60);
		return totalHours.toFixed(2);
	} else {
		// Format as time: 4:30
		const formattedHours = hoursNum.toString().padStart(2, '0');
		const formattedMinutes = minutesNum.toString().padStart(2, '0');
		return `${formattedHours}:${formattedMinutes}`;
	}
}

export function convertToTitleCase(inputString: any) {
	// Split the input string by underscores
	const words = inputString.split('_');

	// Capitalize the first letter of each word
	const capitalizedWords = words.map((word: any) => {
		return word.charAt(0).toUpperCase() + word.slice(1);
	});

	// Join the words with a space
	const result = capitalizedWords.join(' ');

	return result;
}

export function formatNumberWithCommas(number: any) {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatNumberWithCommasV2(number: any) {
	return Number(number)
		.toFixed(2)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function divideTimeInHalf(hours: any, minutes: any) {
	// Convert hours and minutes to total minutes
	const totalMinutes = hours * 60 + minutes;

	// Calculate half of the total minutes
	const halfTotalMinutes = Math.floor(totalMinutes / 2);

	// Calculate the new hours and minutes
	const halfHours = Math.floor(halfTotalMinutes / 60);
	const halfMinutes = halfTotalMinutes % 60;

	// Return an object with half hours and half minutes

	return {
		halfHours,
		halfMinutes,
	};
}

export function addTimeToTime(
	hoursToAdd: number,
	minutesToAdd: number,
	currentHours: number,
	currentMinutes: number
) {
	// Convert current time to total minutes
	const totalMinutes = currentHours * 60 + currentMinutes;

	// Add the hours and minutes to the total minutes
	const newTotalMinutes = totalMinutes + hoursToAdd * 60 + minutesToAdd;

	// Calculate the new hours and minutes
	const newHours = Math.floor(newTotalMinutes / 60);
	const newMinutes = newTotalMinutes % 60;

	// Return an object with the new hours and minutes
	return {
		newHours,
		newMinutes,
	};
}

// export function isDateRangeDisabled(
// 	startDate: any,
// 	endDate: any,
// 	disabledDates: any
// ) {
// 	// Convert the startDate and endDate strings to Date objects
// 	startDate = new Date(startDate);
// 	endDate = new Date(endDate);

// 	// Loop through the range of dates from startDate to endDate
// 	for (
// 		let currentDate = startDate;
// 		currentDate <= endDate;
// 		currentDate.setDate(currentDate.getDate() + 1)
// 	) {
// 		// Convert the currentDate to a string in the format 'YYYY-MM-DD'
// 		const currentDateStr = moment(currentDate).format('YYYY-MM-DD');

// 		// Check if the currentDateStr is in the list of disabledDates
// 		if (disabledDates.includes(currentDateStr)) {
// 			return true; // Date in range is disabled
// 		}
// 	}

// 	return false; // No disabled dates found in the range
// }

export function isDateRangeDisabled(
	startDate: any,
	endDate: any,
	disabledDates: any
) {
	const start = moment.tz(startDate, TIMEZONE).startOf('day');
	const end = moment.tz(endDate, TIMEZONE).startOf('day');
	const current = start.clone();

	while (current.isSameOrBefore(end)) {
		const currentDateStr = current.format('YYYY-MM-DD');

		if (disabledDates.includes(currentDateStr)) {
			return true; // A disabled date is within the range
		}

		current.add(1, 'day');
	}

	return false; // No disabled dates found in the range
}

export function isNullOrUndefined(value: any) {
	return null === value || undefined === value;
}

export function isBlank(value: any) {
	return (
		null === value ||
		undefined === value ||
		value.toString().trim().length === 0
	);
}

export function hasText(value: any) {
	return !isBlank(value);
}
export function divideTimeBySlots(
	hours: number,
	minutes: number,
	divisor: number
) {
	if (divisor <= 0) {
		return 'Divisor must be greater than zero';
	}

	const totalTimeInMinutes = hours * 60 + minutes;
	const dividedTimeInMinutes = totalTimeInMinutes / divisor;

	const dividedHours = Math.floor(dividedTimeInMinutes / 60);
	const dividedMinutes = Math.floor(dividedTimeInMinutes % 60);

	return { dividedHours, dividedMinutes };
}

export function makeTotalTime(timeArray: any) {
	let totalHours = 0;
	let totalMinutes = 0;

	// Loop through the array of time objects and add up the hours and minutes
	for (const timeObj of timeArray) {
		if (
			timeObj &&
			typeof timeObj.minutes === 'number' &&
			typeof timeObj.hours === 'number'
		) {
			totalHours += timeObj.hours;
			totalMinutes += timeObj.minutes;
		}
	}

	// Calculate carryover hours from extra minutes
	totalHours += Math.floor(totalMinutes / 60);
	totalMinutes %= 60;
	return { hours: totalHours, minutes: totalMinutes };
}

export function timeDifference(time1: any, time2: any) {
	// Extract hours and minutes from the time objects
	const { hours: hours1, minutes: minutes1 } = time1;
	const { hours: hours2, minutes: minutes2 } = time2;

	// Calculate the total minutes for each time
	const totalMinutes1 = hours1 * 60 + minutes1;
	const totalMinutes2 = hours2 * 60 + minutes2;

	// Calculate the absolute difference in minutes
	const minuteDifference = Math.abs(totalMinutes1 - totalMinutes2);

	// Calculate hours and remaining minutes
	const hoursDifference = Math.floor(minuteDifference / 60);
	const remainingMinutes = minuteDifference % 60;

	return { hours: hoursDifference, minutes: remainingMinutes };
}

// export function generateDateRange(startDateStr: any, endDateStr: any) {
// 	const dateList = [];
// 	const startDate = new Date(startDateStr);
// 	const endDate = new Date(endDateStr);

// 	while (startDate <= endDate) {
// 		const year = startDate.getFullYear();
// 		const month = String(startDate.getMonth() + 1).padStart(2, '0');
// 		const date = String(startDate.getDate()).padStart(2, '0');
// 		dateList.push(`${year}-${month}-${date}`);
// 		startDate.setDate(startDate.getDate() + 1);
// 	}

// 	return dateList;
// }

export function generateDateRange(startDateStr: any, endDateStr: any) {
	const dateList = [];
	const startDate = moment.tz(startDateStr, TIMEZONE).startOf('day');
	const endDate = moment.tz(endDateStr, TIMEZONE).startOf('day');

	const currentDate = startDate.clone();

	while (currentDate.isSameOrBefore(endDate)) {
		dateList.push(currentDate.format('YYYY-MM-DD'));
		currentDate.add(1, 'day');
	}

	return dateList;
}

// export function getLastDateOfMonth(payPeriodEndDate: string | Date) {
// 	const date = new Date(payPeriodEndDate);
// 	date.setMonth(date.getMonth() + 1, 1);
// 	date.setDate(date.getDate() - 1);
// 	return date;
// }

export function getLastDateOfMonth(payPeriodEndDate: string | Date) {
	const date = dayjs(payPeriodEndDate)
		.tz(TIMEZONE)
		.endOf('month')
		.startOf('day');
	// const date = new Date(payPeriodEndDate);
	// date.setMonth(date.getMonth() + 1, 1);
	// date.setDate(date.getD;ate() - 1);
	return date;
}

export function base64ToBlob(base64: string, mime: string) {
	const byteCharacters = atob(base64);
	const arrayBuffer = new ArrayBuffer(byteCharacters.length);
	const uint8Array = new Uint8Array(arrayBuffer);
	for (let i = 0; i < byteCharacters.length; i++) {
		uint8Array[i] = byteCharacters.charCodeAt(i);
	}
	return new Blob([uint8Array], { type: mime });
}

export const getCustomCustomerData = (testData: any) => {
	const parentIds: any = [];
	const childrenIds: any = [];
	testData.forEach((singleData: any) => {
		if (singleData.ParentRef) {
			childrenIds.push(singleData.ParentRef.value);
		} else {
			parentIds.push(singleData);
		}
	});

	function organizeData(data: any, parentId: any) {
		const result = [];
		for (const item of data) {
			if (item.ParentRef && item.ParentRef.value == parentId) {
				const children = organizeData(data, item.Id);
				if (children.length > 0) {
					item.children = children;
				}
				result.push(item);
			}
		}
		return result;
	}

	const organizedData: any = [];

	parentIds.forEach((singleParent: any) => {
		const data = organizeData(testData, singleParent.Id);
		organizedData.push({ ...singleParent, children: data });
	});
};

export function navigateWithPermissions(selectedCompanyPermission: any) {
	const isDashboardPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Dashboard',
		permission: ['view'],
	});
	if (isDashboardPermission) {
		return '/';
	}
	const isEmployeeCostPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Employee Cost',
		permission: ['view'],
	});
	if (isEmployeeCostPermission) {
		return '/employee-costs';
	}
	const isTimeActivityPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Time Logs',
		permission: ['view'],
	});
	if (isTimeActivityPermission) {
		return '/time-activity';
	}
	const isCostAllocationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Cost Allocations',
			permission: ['view'],
		}
	);
	if (isCostAllocationPermission) {
		return '/cost-allocations';
	}
	const isJournalEntriesPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Journal Entries',
			permission: ['view'],
		}
	);
	if (isJournalEntriesPermission) {
		return '/journal-entries';
	}

	// Check for any expense allocation permission
	const isExpenseTransactionPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Expense Transactions',
			permission: ['view'],
		}
	);

	const isExpenseJournalPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Expense Journal',
			permission: ['view'],
		}
	);

	if (isExpenseTransactionPermission || isExpenseJournalPermission) {
		return '/expense-allocation';
	}

	return '/';
}

export function divideTimeAsPerPercentage(
	hours: any,
	minutes: any,
	actions: any[]
) {
	const minutesContribute: any = {};

	// Convert hours and minutes to total minutes
	const totalMinutes = hours * 60 + minutes;
	let totalMinutesContributed = 0;

	for (let i = 0; i < actions.length; i++) {
		const action = actions[i];

		minutesContribute[i] = Math.round(
			(totalMinutes * Number(action.hours)) / 100
		);

		totalMinutesContributed = totalMinutesContributed + minutesContribute[i];
	}

	const diff = totalMinutes - totalMinutesContributed;

	if (diff && diff > 0) {
		minutesContribute[actions.length - 1] =
			minutesContribute[actions.length - 1] + diff;
	} else if (diff && diff < 0) {
		minutesContribute[actions.length - 1] =
			minutesContribute[actions.length - 1] - Math.abs(diff);
	}

	return minutesContribute;
}

export function minToHours(totalMinutes: number) {
	const totalHours = Math.floor(totalMinutes / 60);
	const remainingMinutes = totalMinutes % 60;

	return `${totalHours.toString().padStart(2, '0')}:${remainingMinutes
		.toString()
		.padStart(2, '0')}`;
}

export function getLocalTime(date: Date) {
	const testDateUtc = moment.utc(date);
	const localDate = moment(testDateUtc).local();

	return localDate.format('MM/DD/YYYY');
}

function deepCopy(obj: any) {
	return JSON.parse(JSON.stringify(obj));
}

export function filterSelectedClass(node: any, selectedId: any) {
	node = deepCopy(node);
	if (node.Id === selectedId) {
		node.disabled = true;
	}

	if (node.children && node.children.length > 0) {
		node.children.map((child: any) => filterSelectedClass(child, selectedId));
	}

	return node;
}

// Function to recursively disable nodes with specific id
function disableNodes(node: any, targetId: any) {
	// Deep copy the node to avoid modifying the original object
	const newNode = deepCopy(node);

	// Modify the 'disabled' property if the id matches
	if (newNode.Id === targetId) {
		newNode.disabled = true;
	}

	// Recursively call the function for children and update the 'children' property
	if (newNode.children && newNode.children.length > 0) {
		newNode.children = newNode.children.map((child: any) =>
			disableNodes(child, targetId)
		);
	}

	return newNode;
}

// Function to iterate through the original array and create a new array with modified nodes
export function createModifiedArray(originalArray: any, targetId: any) {
	const modifiedArray = [];

	for (let i = 0; i < originalArray.length; i++) {
		const modifiedNode = disableNodes(originalArray[i], targetId);
		modifiedArray.push(modifiedNode);
	}

	return modifiedArray;
}

export function createModifiedArrayIds(originalArray: any, targetId: any) {
	const modifiedArray = [];

	for (let i = 0; i < originalArray.length; i++) {
		for (let j = 0; j < targetId.length; j++) {
			const modifiedNode = disableNodes(originalArray[i], targetId[j]);
			modifiedArray.push(modifiedNode);
		}
	}

	return modifiedArray;
}

export const generateYearRange = (
	startMonth: string,
	endMonth: string,
	baseYear: number,
	numberOfPeriods: number
) => {
	const startDate = new Date(`${startMonth} 01, ${baseYear - numberOfPeriods}`);
	const endDate = new Date(`${endMonth} 01, ${baseYear}`);
	const periodList = [];
	const currentDate = startDate;
	while (currentDate <= endDate) {
		const startFormatted = currentDate.toLocaleDateString('en-US', {
			month: 'long',
			year: 'numeric',
		});
		const endDateMinusOneMonth = new Date(currentDate);
		endDateMinusOneMonth.setMonth(endDateMinusOneMonth.getMonth() + 11);
		const endFormatted = endDateMinusOneMonth.toLocaleDateString('en-US', {
			month: 'long',
			year: 'numeric',
		});

		const periodString = `${startFormatted} - ${endFormatted}`;
		periodList.push(periodString);

		currentDate.setFullYear(currentDate.getFullYear() + 1);
	}

	return periodList;
};

export function invalidText(value: string | number | null | undefined) {
	return (
		value == null || value == undefined || value.toString().trim().length == 0
	);
}

export const getOptionLabel = (value: string, options: any[]): string => {
	for (const node of options) {
		const nodeLabel =
			node.title ||
			node.Name ||
			node.DisplayName ||
			node.FullyQualifiedName ||
			node.label ||
			'Unknown';

		if (node.value === value) return nodeLabel;

		if (node.children && node.children.length > 0) {
			const childLabel = getOptionLabel(value, node.children);
			if (childLabel && childLabel !== value) return childLabel;
		}
	}
	return value;
};

export const getEntityType = (transaction: any): string => {

	// First priority: Use entityType if it's already set in the transaction
	// This is the most reliable source as it comes directly from the backend/API
	if (transaction.entityType) {

		return transaction.entityType;
	}

	// Try to get entity type from qboObject with multiple possible field names
	if (transaction.qboObject) {

		// Check multiple possible field names for the entity type
		const qboType =
			transaction.qboObject.type ||
			transaction.qboObject.Type ||
			transaction.qboObject.entityType ||
			transaction.qboObject.EntityType ||
			transaction.qboObject.name ||
			transaction.qboObject.Name;

		if (qboType) {
			const typeLower = qboType.toLowerCase().trim();

			// Map QuickBooks entity types to our expected format
			switch (typeLower) {
				case 'purchase':
					return 'Purchase';
				case 'bill':
					return 'Bill';
				case 'billableexpensecharge':
				case 'billable expense charge':
				case 'billableexpense':
					return 'Billable Expense Charge';
				case 'vendorcredit':
				case 'vendor credit':
					return 'VendorCredit';
				case 'expense':
					return 'Expense';
				case 'check':
					return 'Check';
				case 'creditcardcharge':
				case 'credit card charge':
				case 'creditcard':
					return 'CreditCardCharge';
				case 'JournalEntry':
				case 'journal entry':
					return 'JournalEntry';
				case 'deposit':
					return 'Deposit';
				case 'refundreceipt':
				case 'refund receipt':
					return 'RefundReceipt';
				default:
					// If we don't recognize the type, try to use it as-is
					return qboType;
			}
		}
	}

	// Try to determine from paymentType with more comprehensive checks
	// Note: paymentType refers to payment method, not transaction type
	if (transaction.paymentType) {
		const paymentType = transaction.paymentType.toLowerCase().trim();

		// Only use paymentType for specific cases where it indicates transaction type
		if (paymentType.includes('purchase')) return 'Purchase';
		if (paymentType.includes('bill')) return 'Bill';
		if (paymentType.includes('expense')) return 'Expense';
		if (paymentType.includes('credit') && !paymentType.includes('card'))
			return 'VendorCredit';
		if (paymentType.includes('check')) return 'Check';
		if (paymentType.includes('journal')) return 'JournalEntry';
		if (paymentType.includes('deposit')) return 'Deposit';

		// For CreditCard, Cash, etc. - these are payment methods, not transaction types
		// We need to determine the actual transaction type from other fields

	}

	// Try to determine from other transaction fields
	if (transaction.docNumber) {
		const docNumber = transaction.docNumber.toLowerCase().trim();
		if (docNumber.includes('bill')) return 'Bill';
		if (docNumber.includes('purchase')) return 'Purchase';
		if (docNumber.includes('expense')) return 'Expense';
	}

	// Try to determine from memo field
	if (transaction.memo) {
		const memo = transaction.memo.toLowerCase().trim();
		if (memo.includes('bill')) return 'Bill';
		if (memo.includes('purchase')) return 'Purchase';
		if (memo.includes('expense')) return 'Expense';
		if (memo.includes('credit')) return 'VendorCredit';
	}

	// Check if transaction has specific fields that indicate type
	if (transaction.vendorId && transaction.accountId) {
		// This looks like a vendor transaction
		// For CreditCard payments with vendors, it's typically a Purchase
		if (
			transaction.paymentType &&
			transaction.paymentType.toLowerCase().includes('creditcard')
		) {

			return 'Purchase';
		}
		// Otherwise, default to Bill for vendor transactions
		return 'Bill';
	}

	// Additional heuristics based on transaction structure
	if (
		transaction.paymentType &&
		transaction.paymentType.toLowerCase().includes('creditcard')
	) {
		// CreditCard payments are typically Purchases or Expenses
		if (transaction.customerId) {
			// If it has a customer, it might be a customer-related expense

			return 'Expense';
		} else {
			// Otherwise, likely a Purchase
			return 'Purchase';
		}
	}

	// Check for other payment methods
	if (transaction.paymentType) {
		const paymentType = transaction.paymentType.toLowerCase();
		if (paymentType.includes('cash') || paymentType.includes('check')) {
			// Cash/Check payments with vendors are typically Purchases
			if (transaction.vendorId) {

				return 'Purchase';
			}
		}
	}

	// Default fallback - but log this case for debugging
	return 'Purchase';
};

export const parseToNumber = (value: any) => {
	// Handle null, undefined, empty string
	if (!value || value === '' || value === null || value === undefined) {
		return 0;
	}

	// Convert to string for processing
	let stringValue = String(value).trim();

	// Handle empty string after trim
	if (stringValue === '') {
		return 0;
	}

	// Handle accounting format: (123) means -123
	if (stringValue.startsWith('(') && stringValue.endsWith(')')) {
		stringValue = '-' + stringValue.slice(1, -1);
	}

	// Remove currency symbols and common formatting
	stringValue = stringValue
		.replace(/[$£€¥₹₽₩₪฿₫₴₦₵₲₱₡₸₭₮₠₣₧₰₯؋৳৲৴৻૱௹៛₤₥₨]/g, '') // Currency symbols
		.replace(/[,\s'"]/g, ''); // Commas, spaces, quotes

	// Try to parse as number
	const parsedNumber = parseFloat(stringValue);

	// If NaN, return 0
	if (isNaN(parsedNumber)) {
		return 0;
	}

	return parsedNumber;
};


/**
 * Generates QuickBooks Online URL based on entity type and transaction ID
 * @param entityType - The entity type (bill, vendorcredit, journal, purchase/expense)
 * @param txnId - The transaction ID
 * @returns The complete QBO URL
 */
export const generateQBOUrl = (entityType: string, txnId: string, paymentType?: string): string => {
	const qboMode = process.env.REACT_APP_QBO_MODE;
	if(!qboMode) {
		console.error('QBO mode is not set');
		return '';
	}
	const baseUrl = qboMode === 'prod'
		? 'https://app.qbo.intuit.com/app'
		: 'https://app.sandbox.qbo.intuit.com/app';

	// Check if paymentType is CreditCard (case-insensitive)
	if (paymentType && paymentType.toLowerCase() === 'creditcard') {
		return `${baseUrl}/creditcardcredit?txnId=${txnId}`;
	}
	// Map entity types to QBO URL paths
	const entityPathMap: { [key: string]: string } = {
		'bill': 'bill',
		'vendorcredit': 'vendorcredit',
		'journalentry': 'journal',
		'purchase': 'expense', // purchase maps to expense in QBO
		'expense': 'expense',
		'deposit': 'deposit',
		'invoice': 'invoice',
		'creditmemo': 'creditmemo',
		'refundreceipt': 'refundreceipt',
		'salesreceipt': 'salesreceipt',
	};

	const path = entityPathMap[entityType.toLowerCase()];
	return `${baseUrl}/${path}?txnId=${txnId}`;
};
